import { render, staticRenderFns } from "./user-reset-log.vue?vue&type=template&id=dba26528"
import script from "./user-reset-log.vue?vue&type=script&lang=js"
export * from "./user-reset-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports